module.exports = __webpack_public_path__ + "img/acg-logo.ac42b9b1.svg";